import { Component } from '@angular/core';

@Component({
  selector: 'app-sliderimpacto',
  templateUrl: './sliderimpacto.component.html',
  styleUrls: ['./sliderimpacto.component.scss']
})
export class SliderimpactoComponent {

    //CANTIDAD INICIAL
    monto: number = 500;

    //MÍNIMA CANTIDAD DE UTILIDADES
    tratamientos: number = 0;
    consultas: number = 0;
    educacion: number = 0;

    //MÁXIMA CANTIDAD DE UTILIDADES
    COSTOS = {
        tratamiento: 100,
        consulta: 250,
        educacion: 50
    };

  ngOnInit() {
    this.actualizarSimulador();
  }

  calcularImpacto(monto: number) {
    return {
      tratamientos: Math.floor(monto / this.COSTOS.tratamiento),
      consultas: Math.floor(monto / this.COSTOS.consulta),
      educacion: Math.floor(monto / this.COSTOS.educacion)
    };
  }

  actualizarSimulador() {
    const impacto = this.calcularImpacto(this.monto);

    this.tratamientos = impacto.tratamientos;
    this.consultas = impacto.consultas;
    this.educacion = impacto.educacion;
  }

}